import React from "react";
import { isNil } from "ramda";
import { Checkbox, FormControlLabel, Grid, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import InfoIcon from "@material-ui/icons/Info";

const useStyles = makeStyles((theme) => ({
  infoIcon: {
    color: theme.palette.primary.main,
    marginTop: 5,
    marginLeft: 5,
  },
  label: {
    whiteSpace: "nowrap",
    marginLeft: 0,
  },
  tooltipWidth: {
    maxWidth: 300,
  },
}));

const TooltipCheckbox = ({ checkboxLabel, tooltip, ...props }) => {
  const classes = useStyles();

  return (
    <Grid container alignItems={"center"}>
      <Grid item>
        <FormControlLabel
          className={classes.label}
          control={<Checkbox {...props} />}
          label={checkboxLabel}
          wrap="nowrap"
          labelPlacement="start"
        />
      </Grid>
      {!isNil(tooltip) ? (
        <Grid item>
          <Tooltip
            title={tooltip}
            placement="top-end"
            classes={{ tooltip: classes.tooltipWidth }}
          >
            <InfoIcon className={classes.infoIcon} fontSize="inherit" />
          </Tooltip>
        </Grid>
      ) : (
        <div />
      )}
    </Grid>
  );
};

export default TooltipCheckbox;
